var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_17_3",
    "data-name": "Symbol 17 \\u2013 3",
    transform: "translate(-798 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_179",
    className: "cls-1",
    "data-name": "Path 179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 0h6.667A16.667 16.667 0 0 1 40 16.667v6.667A16.667 16.667 0 0 1 23.333 40h-6.666A16.667 16.667 0 0 1 0 23.333v-6.666A16.667 16.667 0 0 1 16.667 0z",
    className: "cls-3",
    transform: "translate(798 30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2A14.57 14.57 0 0 0 6.296 6.296 14.57 14.57 0 0 0 2 16.666v6.667c0 3.918 1.526 7.601 4.296 10.371A14.57 14.57 0 0 0 16.666 38h6.667c3.918 0 7.601-1.526 10.371-4.296A14.57 14.57 0 0 0 38 23.334v-6.667c0-3.918-1.526-7.601-4.296-10.371A14.57 14.57 0 0 0 23.334 2h-6.667m0-2h6.666C32.538 0 40 7.462 40 16.667v6.666C40 32.538 32.538 40 23.333 40h-6.666C7.462 40 0 32.538 0 23.333v-6.666C0 7.462 7.462 0 16.667 0z",
    className: "cls-4",
    transform: "translate(798 30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(808 39.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    d: "M18.5 20H1.1A1.11 1.11 0 0 1 0 18.9a7.6 7.6 0 0 1 7.6-7.6h4.6a7.6 7.6 0 0 1 7.6 7.6 1.3 1.3 0 0 1-1.3 1.1zM2.4 17.7h14.9a5.155 5.155 0 0 0-5.1-4.1H7.6a5.285 5.285 0 0 0-5.2 4.1z",
    className: "cls-2",
    "data-name": "Path 177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    d: "M9.8 10.1a5 5 0 1 1 5-5 4.951 4.951 0 0 1-5 5zm0-7.8A2.7 2.7 0 1 0 12.5 5a2.571 2.571 0 0 0-2.7-2.7z",
    className: "cls-2",
    "data-name": "Path 178"
  })))));
}
export default __webpack_public_path__ + "static/media/ic_user.4c0e8f1a.svg";
export { SvgIcUser as ReactComponent };